export default __webpack_public_path__ + "static/media/Covid_19_India.a90c9b9c.webp";